import style from './App.css';

function Show(props) {

    const fullMonthNames = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

    function convertToDateTime(timeStr) {
        
        if (timeStr.length !== 6) {
            throw new Error("Invalid time format. Expected HHMMSS.");
        }
    
        // Extract hours, minutes, and seconds from the string
        let hours = parseInt(timeStr.substring(0, 2), 10);
        let minutes = parseInt(timeStr.substring(2, 4), 10);
        let seconds = parseInt(timeStr.substring(4, 6), 10);
    
        // Get the current date
        let now = new Date();
    
        // Create a new date with the current date and the provided time
        let dateTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, seconds);
    
        return dateTime;
    }
    if(props.show != undefined){

        let formatedTime = (convertToDateTime(props.show.start_time));
        //let options = { hour: '2-digit', minute: '2-digit', hour12: true };
        let options = { hour: '2-digit', minute: '2-digit', hour12: true };
        const day = formatedTime.getDate(); // Gets the day of the month (e.g., 2)
        const month = formatedTime.getMonth();

        let timeString = formatedTime.toLocaleTimeString('en-US', options);
        let trimmedDescription = "";
        if(props.show.description!=undefined){
            trimmedDescription =   props.show.description.substring(0, 100);
        }
        //
        //
    
        let epTitle = props.show.title;
        return(<div className="show" onClick={()=>{props.handleShowClick(props.showIndex)}}>
            <div className="showColImage">
                <img className="showImage" src={props.show.thumbnail_path} />
            </div>
            <div className="showCol" onClick={()=>{props.handleShowClick(props.showIndex)}}>  
                <h5>{timeString} - {fullMonthNames[props.selectedMonth -1 ] } {props.selectedDay}</h5>
                <h4>{epTitle}</h4>
                
            </div>
            
            </div>)
    }else{
        return(null)
    }
    
}
export default Show;